import { react2panel } from 'common/util/react2panel';
import { ConversionColumnViz } from './index';
export const ConversionColumnVizPanel = react2panel("mp-conversion-column-viz", ConversionColumnViz, {
  contexts: ["urlManager", "segmentFilterController"]
});